import { DateTime } from 'luxon'

import { ActivityItem as ActivityItemBase, Text } from '@domain-group/suit-theme'

import useActivity from '@hooks/useActivity'

import { ActivityModel } from '@models/types'

import { destructiveActions } from '@functions/activity'

const renderActionText = (key: ActivityModel['key']) => {
  if (key){
    const [subject, action] = key.split('.')
    return `${action} ${subject.split('_').join(' ')}`
  }

  return undefined
}

const renderActivityTitle = (parameters: ActivityModel['parameters']) => {
  if (parameters && parameters.title){
    return (
      <Text as="span" fontStyle="italic" marginRight="small">
        - {parameters.title}
      </Text>
    )
  }

  return undefined
}

const renderTrackable = (trackable: ActivityModel['trackable']) => {
  if (trackable){
    return (
      <Text as="span" color="bodyFontLightColor" marginRight="small" style={{ textTransform: 'none' }}>
        for {trackable.type} #{trackable.id}
      </Text>
    )
  }

  return undefined
}

interface ActivityItemProps {
  activity: ActivityModel,
  isLastActivity: boolean,
}

const ActivityItem = (props: ActivityItemProps) => {
  const {
    activity,
    activity: {
      action, key, parameters, trackable,
    },
    isLastActivity,
  } = props

  const createdDateString = activity?.dates?.created?.date_time

  const {
    callbacks: { manageActivity },
  } = useActivity(activity)

  return (
    <ActivityItemBase
      actionText={renderActionText(key)}
      boxProps={{ paddingTop: 'medium', paddingBottom: isLastActivity ? 0 : 'medium' }}
      actionType={action && destructiveActions.includes(action) ? 'destructive' : 'default'}
      dateTimeText={
        createdDateString
          ? DateTime.fromFormat(createdDateString, 'dd/MM/yyyy HH:mm').toFormat("ccc, dd LLL yyyy 'at' h:mm a")
          : 'Not Set'
      }
      description={(
        <>
          {renderTrackable(trackable)}
          {renderActivityTitle(parameters)}
        </>
      )}
      imageUrl={activity?.owner?.image?.square_url}
      onClick={() => manageActivity()}
      roleName={activity?.owner?.role}
      title={activity?.owner?.title}
    />
  )
}

export default ActivityItem
